export const ADMINDASHBOARD_DATA_GET="ADMINDASHBOARD_DATA_GET"
export const ADMINDASHBOARD_DATA_SUCCESS="ADMINDASHBOARD_DATA_SUCCESS"